import { render, staticRenderFns } from "./BorrowerMsg.vue?vue&type=template&id=4be791a2&"
import script from "./BorrowerMsg.vue?vue&type=script&lang=js&"
export * from "./BorrowerMsg.vue?vue&type=script&lang=js&"
import style0 from "./BorrowerMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports